module.exports = __webpack_public_path__ + "static/media/global-background.1ec25333.png";